import Cookies from 'js-cookie'
import axios from 'axios'
import store from '../store'


export const ApiCaller = (customHeader = null) => {
  let currentPage = 'manager'
  let token = ''
  if (/^\/manager/.test(window.location.pathname)) {
    token = Cookies.get('current_manager_token')
  }
  else {
    currentPage = 'owner'
    token = Cookies.get('current_owner_token')
  }

  const header = {
    'Authorization': `Bearer ${token}`,
    'AUTH-FROM-PAGE': currentPage,
  }

  const instance = axios.create({
    headers: Object.assign(customHeader || {}, header),
    timeout: 100000
  })
  instance.interceptors.response.use((response) => {
    return response
  }, (error) => {
    let errorMessage = error.toString()
    if (error.response) {
      if (error.response.data.message) {
        errorMessage = error.response.data.message
      }
      if (error.response.status === 401) {
        localStorage.clear()
        setTimeout(() => {
          window.location.href = '/login'
        }, 2000)
      }
    }
    store.commit('message/SET_MESSAGE', errorMessage)
    return error.response
  })
  return instance
}
